import styled from 'styled-components';

export const MobileWrapper = styled.div<{ limitHeight?: boolean }>`
  width: 100%;
  margin-bottom: 70px;
  z-index: 10;
  overflow-x: hidden;
  ${(props) => (props.limitHeight ? `height: calc(100vh - 118px)` : '')};
`;

export const MobileHeaderBar = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;

  & > div {
    padding-left: 10px;
    display: flex;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
    }
  }

  align-items: center;
`;

export const AppContent = styled.div<{
  drawerOpen?: boolean;
  showBanner?: boolean;
}>`
  position: relative;
  padding-top: ${(props) => (props.showBanner ? '120px' : '52px')};
  margin-left: 65px;
  margin-right: ${(props) => (props.drawerOpen ? `280px` : `0px`)};
  min-height: calc(100vh - 68px);
  box-sizing: border-box;
  background-color: ${(props) => props.theme.palette.background.default};
  z-index: 10;
  height: calc(100vh - 68px);

  ${(props) => props.theme.breakpoints.down('lg')} {
    margin-right: 0;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 0;
    margin-left: 0;
  }

  ${({ theme, drawerOpen }) =>
    `transition: ${theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing[drawerOpen ? 'easeOut' : 'sharp'],
      duration:
        theme.transitions.duration[
          drawerOpen ? 'enteringScreen' : 'leavingScreen'
        ],
    })}`}
`;

export const CuratorAppContent = styled.div<{
  curating: boolean;
  drawerOpen?: boolean;
}>`
  position: relative;
  padding-top: ${(props) => (props.curating ? '120px' : '52px')};
  margin-left: 65px;
  margin-right: ${(props) => (props.drawerOpen ? '280px' : '0px')};
  min-height: calc(100vh - 68px);
  box-sizing: border-box;
  background-color: ${(props) => props.theme.palette.background.default};
  z-index: 10;
  height: calc(100vh - 68px);

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
  }

  ${({ theme, drawerOpen }) =>
    `transition: ${theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing[drawerOpen ? 'easeOut' : 'sharp'],
      duration:
        theme.transitions.duration[
          drawerOpen ? 'enteringScreen' : 'leavingScreen'
        ],
    })}`}
`;

export const Hamburger = styled.div`
  margin-left: 10px;
  min-width: 25px;
  min-height: 25px;
  width: 25px;
  height: 25px;
  padding-left: 0 !important;
  font-size: 25px;
`;
